// import QueryString from "qs";
import axios from "../axiosPlugin.js";

const getNonArrivalTicketList = data => {
  return axios({
    url: "/api/nonArrivalTicket/list",
    method: "get",
    data: {
      data
    },
  });
};

const createNonArrivalTicket = data => {
  return axios({
    url: "/api/nonArrivalTicket/create",
    method: "post",
    data: {
      data
    },
  });
};

const deleteNonArrivalTicket = data => {
  return axios({
    url: "/api/report/deleteProductSalesReportItem?itemId=" + data.itemId + "&transactionId=" + data.transactionId + "&userId=" + data.userId,
    method: "get",
    data: {},
  });
};

const getFilmList = data => {
  const adminType = window.localStorage.getItem("adminType");
  const brandId = window.localStorage.getItem("brandId");
  const cinemaId = window.localStorage.getItem("cinemaId");
  const adminScopeData = {};

  if (adminType === "brand" && brandId) {
    adminScopeData.brandId = brandId;
  }

  if (adminType === "cinema" && cinemaId) {
    adminScopeData.cinemaId = cinemaId;
  }

  return axios({
    url: "/api/film/listMap",
    method: "get",
    data: {
      data: {
        ...data,
        ...adminScopeData,
      },
    },
  });
};

// const getDeviceList = cinemaId => {
//   return axios({
//     url: "/api/device/list?page=0&pageSize=9999&status=active&cinemaId=" + cinemaId,
//     method: "get",
//     data: {},
//   });
// };

const getScheduleList = (filmId, cinemaId) => {
  return axios({
    url: "/api/schedule/list?dateType=DAYS&filmIds=" + filmId + "&cinemaId=" + cinemaId,
    method: "get",
    data: {},
  });
};

const getNewScheduleList = (filmId, cinemaId) => {
  return axios({
    url: "/api/schedule/listByNonArrival?cinemaId=" + cinemaId + "&filmIds=" + filmId,
    method: "get",
    data: {}
  });
};
const exportCSV = QueryString => {
  return axios({
    url: "/api/nonArrivalTicket/export?" + QueryString,
    method: "post",
    data: {},
  });
};

const getAdvanceCouponTypeList = cinemaId => {
  return axios({
    url: "/api/advanceCouponType/list?page=0&pageSize=9999&cinemaId=" + cinemaId,
    method: "get",
    data: {},
  });
};

export {
  getNonArrivalTicketList,
  createNonArrivalTicket,
  deleteNonArrivalTicket,
  getFilmList,
  // getDeviceList,
  getScheduleList,
  exportCSV,
  getAdvanceCouponTypeList,
  getNewScheduleList
};
